import React, { useEffect } from "react";
import { Input, Button, Divider, Form, Row, Col } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { putApi } from "redux/sagas/putApiSaga";
import { SERVER_IP } from "assets/Config";
import { API_STATUS } from "constants/app-constants";
import { resetApiStatus } from "redux/reducers/globals/globalActions";
import { postApi } from "redux/sagas/postApiDataSaga";

const { TextArea } = Input;

const AddMaterial = ({ handleClose, editMaterials, setMaterialAddModal }) => {
	const [form] = Form.useForm();
	const globalRedux = useSelector((state) => state?.globalRedux);
	const dispatch = useDispatch();

	const addMaterial = (values) => {
		let data = {
			...values,

			displayName: values.displayName,
			email: values.email,
			mobile: values.mobile,
			orgId: globalRedux?.selectedOrganization?._id,
		};
		dispatch(postApi(data, "ADD_MATERIAL"));
	};

	const handleEdit = (values) => {
		let data = {
			...values,
			orgId: globalRedux?.selectedOrganization?._id,
		};
		let url = `${SERVER_IP}material/${editMaterials._id}?orgId=${globalRedux?.selectedOrganization?._id}`;
		dispatch(putApi(data, "EDIT_MATERIAL", url));
	};

	useEffect(() => {
		if (
			globalRedux.apiStatus.ADD_MATERIAL === "SUCCESS" ||
			globalRedux.apiStatus.EDIT_MATERIAL === "SUCCESS"
		) {
			dispatch(
				resetApiStatus(editMaterials ? "EDIT_MATERIAL" : "ADD_MATERIAL")
			);
			setMaterialAddModal(false);
			handleClose();
		}
	}, [
		globalRedux.apiStatus,
		editMaterials,
		setMaterialAddModal,
		handleClose,
		dispatch,
	]);

	const layer1FormCol = {
		labelCol: {
			span: 12,
		},
		wrapperCol: {
			span: 12,
		},
	};

	const loading =
		globalRedux.apiStatus.ADD_MATERIAL === API_STATUS.PENDING ||
		globalRedux.apiStatus.EDIT_MATERIAL === API_STATUS.PENDING;

	return (
		<Row>
			<Col span={24}>
				{/* <Row style={{ backgroundColor: '#fff', padding: '10px 0px' }}>
					<Col>
						<h6 style={{ marginBottom: '0px' }}>{editMaterials ? 'Edit' : 'New'} Material</h6>
					</Col>
				</Row>
				<Divider /> */}
				<Row style={{ paddingTop: 0 }}>
					<Col span={24}>
						<Form
							name="add-material"
							className="required_in_right"
							labelAlign="left"
							form={form}
							onFinish={!editMaterials ? addMaterial : handleEdit}
							{...layer1FormCol}
						>
							<Form.Item
								label="Material Name"
								name="materialName"
								initialValue={editMaterials?.materialName}
								rules={[
									{
										required: true,
										message: "This Field is Required!",
									},
								]}
							>
								<Input placeholder="Material Name" />
							</Form.Item>
							<Form.Item
								label="Part Number"
								name="partNumber"
								initialValue={editMaterials?.partNumber}
								rules={[
									{
										required: true,
										message: "This Field is Required!",
									},
								]}
							>
								<Input placeholder="Part Number" />
							</Form.Item>
							<Form.Item
								label="Remarks"
								name="remarks"
								initialValue={editMaterials?.remarks}
							>
								<TextArea />
							</Form.Item>
							<Form.Item
								wrapperCol={{
									offset: 0,
									span: 24,
								}}
							>
								<Row justify="space-between">
									<Button
										onClick={() => setMaterialAddModal(false)}
										style={{ width: "49%" }}
										danger
									>
										Cancel
									</Button>
									<Button
										loading={loading}
										type="primary"
										style={{ width: "49%", marginRight: 5 }}
										htmlType="submit"
									>
										{editMaterials ? "Update" : "Create"}
									</Button>
								</Row>
							</Form.Item>
						</Form>
					</Col>
				</Row>
			</Col>
		</Row>
	);
};

export default AddMaterial;
